//export const numdtest =  /^[+-]?\d*(?:[.,]\d*)?$/;
export const numtest = /^[0-9\b]+$/;
//export const floattest = /^[+-]?\d+(\.\d+)?$/;
export const floattest = /^[+-]?\d*(?:[.,]\d*)?$/
export const numdtest = /^[+-]?\d*(?:[.,]\d{0,2})?$/ 
export const numtests = /^[0-9-\b]+$/;
export const alpha = /^[A-Za-z]+$/;
export const alphanum = /^[0-9a-zA-Z]*$/;
export const alphaspace = /^[A-Za-z\d\-_\s]+$/i;
export const email = /\S+@\S+\.\S+/;

export const fieldvalidator = (...props) => {
  var alarmfalse = false;
  props.map(t => {
    if(t === "" || t === undefined || t === NaN || t === "0" || t === null ) {
      alarmfalse = true;
   
    }
  })
  return alarmfalse;
}

export const filenamevalid = (filename) => {
  let count = 0;
    
    if(filename.size >= 524288)
    {
      return false;
    }
  // looping through the items
  for (let i = 0; i < filename.name.length; i++) {
  
      // check if the character is at that position
      if (filename.name[i] === ".") {
       
          count += 1;
      }
  }
  
  return count === 1 ? true : false ;
}

export const bannernamevalid = (filename) => {
  let count = 0;
    
    if(filename.size >= 2097152)
    {
      return false;
    }
  // looping through the items
  for (let i = 0; i < filename.name.length; i++) {
  
      // check if the character is at that position
      if (filename.name[i] === ".") {
       
          count += 1;
      }
  }
  
  return count === 1 ? true : false ;
}